import { Btn, Sel, PR } from '../../components/ui';
import { STS } from '../../utils/constants';
import { renderIcon } from '../../utils/icons';
import { api } from '../../utils/api';
import WorkflowPhaseStepper from '../../components/WorkflowPhaseStepper';
import { WorkflowStageCards, CloudStorageCard } from './workflow';
import { SiteDetailTabs } from './tabs';

export default function SiteDetailView({ siteData, selSite, setSelSite, setExpWS, setWfStage, setSiteData, selItems, setSelItems, user, users, partners, canAdmin, canEdit, isViewer, mobile, isDark, theme, T, R, N, updateItem, deleteItem, addNote, loadSite, refresh, showConfirm, nav, api: apiRef, selectedPhases, setSelectedPhases }) {
  const site = siteData.site;
  const wsList = siteData.workstreams || [];
  let tot = 0, comp = 0, ip = 0, cr = 0, cd = 0;
  wsList.forEach(ws => ws.items.forEach(it => {
    tot++;
    if (it.status === 'Complete') comp++;
    if (it.status === 'In Progress') ip++;
    if (it.is_critical) { cr++; if (it.status === 'Complete') cd++; }
  }));
  const pct = tot ? Math.round(comp / tot * 100) : 0;

  const stages = ['find_it', 'vet_it', 'buy_it', 'entitle_it', 'package_sell'];
  const stageColors = { find_it: '#F59E0B', vet_it: '#1a73e8', buy_it: '#8B5CF6', entitle_it: '#F59E0B', package_sell: '#22C55E' };
  const stageLabels = { find_it: 'Find It', vet_it: 'Vet It', buy_it: 'Buy It', entitle_it: 'Entitle It', package_sell: 'Package & Sell' };
  const cur = site.macro_stage || 'find_it';
  const curIdx = stages.indexOf(cur);
  const col = stageColors[cur] || '#1a73e8';

  return (
    <div className="stagger-children" style={{ maxWidth: mobile ? 1200 : 'none', margin: '0 auto' }}>
      {/* Breadcrumb + Print */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14, flexWrap: 'wrap', gap: 10 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 14 }}>
          <button onClick={() => { setSelSite(null); setExpWS(new Set()); setSiteData(null); setWfStage(null); window.history.pushState({ view: 'sites' }, '', '/sites'); }} style={{ background: 'none', border: 'none', color: theme.textSecondary, cursor: 'pointer', fontSize: 14, padding: 0 }}>Sites</button>
          <span style={{ color: theme.textSecondary }}>›</span>
          <span style={{ color: theme.text, fontWeight: 600 }}>{site.name}</span>
        </div>
        <Btn sm primary onClick={() => {
          const w = window.open('', '_blank');
          let html = '<html><head><title>' + site.name + ' — Lightning Partners HQ</title><style>body{background:#fff;font-family:"Segoe UI",Arial,sans-serif;max-width:900px;margin:0 auto;padding:32px;color:#1a1a1a}h1{font-size:28px;font-weight:300;color:#1a1a1a;border-bottom:3px solid #16A34A;padding-bottom:12px;margin-bottom:4px}h2{color:#1a1a1a;margin-top:28px;font-size:18px;font-weight:600;border-bottom:1px solid #e5e7eb;padding-bottom:6px}table{width:100%;border-collapse:collapse;margin:10px 0}th{background:#16A34A;color:#fff;padding:10px 12px;text-align:left;font-size:11px;text-transform:uppercase;letter-spacing:0.04em}td{padding:8px 12px;border-bottom:1px solid #e5e7eb;font-size:12px}tr:nth-child(even){background:#f9fafb}.overdue{color:#ef4444;font-weight:bold}.complete{color:#16A34A}.stats{display:flex;gap:16px;margin:16px 0;flex-wrap:wrap}.stat{background:#f0fdf4;border:1px solid #dcfce7;padding:14px 24px;border-radius:10px;text-align:center;min-width:110px}.stat-num{font-size:28px;font-weight:300;color:#16A34A}.stat-label{font-size:10px;color:#666;text-transform:uppercase;letter-spacing:0.08em;margin-top:2px}.brand{color:#666;font-size:11px;margin-top:4px}@media print{body{padding:0}}</style></head><body>';
          html += '<h1>' + site.name + '</h1><p class="brand">Lightning Partners HQ — Report generated ' + new Date().toLocaleDateString() + '</p>';
          html += '<div class="stats"><div class="stat"><div class="stat-num">' + pct + '%</div><div class="stat-label">Complete</div></div><div class="stat"><div class="stat-num">' + comp + '/' + tot + '</div><div class="stat-label">Items Done</div></div></div>';
          const today3 = new Date().toISOString().split('T')[0];
          wsList.forEach(ws => {
            const d2 = ws.items.filter(i => i.status === 'Complete').length;
            html += '<h2>' + ws.name + ' (' + d2 + '/' + ws.items.length + ')</h2><table><tr><th>Item</th><th>Priority</th><th>Status</th><th>Due</th><th>Assigned</th></tr>';
            ws.items.forEach(i => {
              const od = i.due_date && i.due_date < today3 && i.status !== 'Complete';
              html += '<tr><td>' + i.doc + '</td><td>' + i.priority + '</td><td class="' + (i.status === 'Complete' ? 'complete' : '') + '">' + i.status + (od ? ' <span class="overdue">OVERDUE</span>' : '') + '</td><td>' + (i.due_date || '—') + '</td><td>' + (i.assigned_name || '—') + '</td></tr>';
            });
            html += '</table>';
          });
          html += '</body></html>';
          w.document.write(html); w.document.close(); w.print();
        }}>{renderIcon('file-text', 13)} Print Report</Btn>
      </div>

      {/* Site header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 20, flexWrap: 'wrap' }}>
        <PR pct={pct} sz={mobile ? 60 : 72} sk={6} />
        <div style={{ flex: 1, minWidth: 200 }}>
          <h1 style={{ fontSize: mobile ? 22 : 28, fontWeight: 400, fontFamily: "'DM Sans', sans-serif", letterSpacing: '-0.02em', margin: 0, color: theme.text, lineHeight: 1.2 }}>{site.name}</h1>
          <div style={{ display: 'flex', gap: 16, marginTop: 6, fontSize: 14, flexWrap: 'wrap', fontFamily: "'DM Sans', sans-serif" }}>
            <span style={{ color: '#4ADE80', fontWeight: 500 }}>{comp}/{tot} <span style={{ color: 'rgba(255,255,255,0.55)', fontWeight: 400 }}>complete</span></span>
            <span style={{ color: '#4ADE80', fontWeight: 500 }}>{ip} <span style={{ color: 'rgba(255,255,255,0.55)', fontWeight: 400 }}>active</span></span>
            {(cr - cd) > 0 && <span style={{ color: '#EF4444', fontWeight: 500 }}>{cr - cd} <span style={{ color: 'rgba(255,255,255,0.55)', fontWeight: 400 }}>critical</span></span>}
          </div>
        </div>
      </div>

      {/* Progress bar */}
      <div style={{ height: 6, background: 'rgba(255,255,255,0.06)', borderRadius: 3, overflow: 'hidden', marginBottom: 20 }}>
        <div style={{ height: '100%', width: `${pct}%`, background: pct >= 100 ? '#4ADE80' : 'linear-gradient(90deg, #4ADE80, #4ADE80)', borderRadius: 3, transition: 'width 600ms cubic-bezier(0.16,1,0.3,1)', boxShadow: pct > 0 ? '0 0 10px rgba(80,232,144,0.3)' : 'none' }} />
      </div>

      {/* Workflow phase stepper */}
      <WorkflowPhaseStepper wsList={wsList} gates={siteData.gates || []} selectedPhases={selectedPhases} onPhaseClick={(name) => {
        if (name === '__clear__') { setSelectedPhases(new Set()); return; }
        if (name === '__hide_all__') { setSelectedPhases(new Set(['__none__'])); return; }
        setSelectedPhases(prev => {
          const next = new Set(prev);
          if (next.has(name)) next.delete(name);
          else next.add(name);
          return next;
        });
      }} />

      {/* Sold banner */}
      {site.macro_stage === 'sold' && (
        <div style={{ background: 'linear-gradient(135deg,rgba(22,101,52,0.13),rgba(21,128,61,0.13))', border: '2px solid #15803d50', borderRadius: 12, padding: '16px 24px', marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
          <span style={{ fontSize: 28, fontWeight: 900, color: '#15803d', letterSpacing: 4 }}>✅ SOLD TO OFF TAKER</span>
          {(() => { const fn = typeof site.financials === 'string' ? JSON.parse(site.financials || '{}') : site.financials || {}; return fn.final_sale_price ? <span style={{ color: '#15803d', fontSize: 16, fontWeight: 600 }}>{'$' + Number(fn.final_sale_price).toLocaleString()}</span> : null; })()}
        </div>
      )}

      {/* Workflow stage cards */}
      <div style={{ marginBottom: 20 }}>
        <WorkflowStageCards
          wsList={wsList}
          gates={siteData.gates || []}
          users={users}
          partners={partners}
          canAdmin={canAdmin}
          isDark={isDark}
          theme={theme}
          mobile={mobile}
          updateItem={updateItem}
          deleteItem={deleteItem}
          selectedPhases={selectedPhases}
          onGateAction={async (sid, phase, status) => {
            try { await api.put('/api/phase-gates/' + sid + '/' + encodeURIComponent(phase), { status }); loadSite(sid); } catch (e) { alert(e.message); }
          }}
          siteId={selSite}
        />
      </div>

      {/* Bulk action bar */}
      {selItems.size !== 0 && (
        <div style={{ position: 'sticky', bottom: 20, zIndex: 10, margin: '16px 0', padding: '12px 18px', background: 'linear-gradient(135deg,#1E1E22ee,#161619ee)', border: '1px solid ' + N + '60', borderRadius: 14, display: 'flex', alignItems: 'center', gap: 12, backdropFilter: 'blur(20px)', boxShadow: '0 8px 32px rgba(0,0,0,0.4)' }}>
          <span style={{ fontSize: 14, fontWeight: 700, color: '#FFFFFF' }}>{selItems.size} selected</span>
          <Sel onChange={async e => {
            if (!e.target.value) return;
            try { await api.post('/api/items/bulk-update', { ids: [...selItems], status: e.target.value }); setSelItems(new Set()); loadSite(selSite); refresh(); } catch (er) { alert(er.message); }
            e.target.value = '';
          }} style={{ width: 140 }}>
            <option value="">Update status...</option>
            {STS.map(st => <option key={st} value={st}>{st}</option>)}
          </Sel>
          <Btn sm danger onClick={() => setSelItems(new Set())}>Clear</Btn>
        </div>
      )}

      {/* Cloud storage */}
      <CloudStorageCard siteId={selSite} isAdmin={user.role === 'admin'} theme={theme} isDark={isDark} />

      {/* Site tabs */}
      <SiteDetailTabs siteId={selSite} site={site} notes={siteData.notes || []} onAddNote={isViewer ? null : t => addNote(selSite, t)} user={user} loadSite={loadSite} workstreams={wsList} isViewer={isViewer} />
    </div>
  );
}
